function Header() {
  return (
    <header className='app-header'>
      <img src='logo512.png' alt='React logo' />
      <h1 className="title">The React Quiz</h1>
    </header>
  );
}

export default Header;
